export const useWeatherService = () => {
  const { client } = useApiV2();

  const getNearestWeatherStation = async (siteId: number) => {
    const response = await client.GET('/v2/sites/{site_id}/nearest_weather_stations/', {
      params: {
        path: {
          site_id: siteId,
        },
      },
    });
    return response.data ?? [];
  };

  return {
    getNearestWeatherStation,
  };
};
